import { getDeviceStatusIcon } from '@/constants/device';
import { qx_eDeviceConnectionStatus_enum, qx_ePACSStatus_enum } from '@/graphql/types';
import type { AppColor } from '@/types/colors';

type IntrusionStatusSource = {
  enabled?: boolean | null;
  connectionStatus?: qx_eDeviceConnectionStatus_enum | null;
  gateway?: {
    connectionStatus?: boolean | null;
  } | null;
  gatewayConnected?: boolean | null;
} | null | undefined;

export interface IntrusionStatus {
  color: AppColor;
  label: string;
}

export const getIntrusionStatus = (panel: IntrusionStatusSource): IntrusionStatus => {
  const gatewayConnected =
    typeof panel?.gatewayConnected === 'boolean' ? panel.gatewayConnected : Boolean(panel?.gateway?.connectionStatus);

  const connection =
    panel?.enabled === false
      ? 'Disabled'
      : panel?.connectionStatus ?? qx_eDeviceConnectionStatus_enum.Unknown;
  const status = getDeviceStatusIcon(
    gatewayConnected,
    connection,
    qx_ePACSStatus_enum.Unknown,
    qx_ePACSStatus_enum.Unknown
  );

  return {
    color: status?.color || 'grey',
    label: status?.tooltip || 'Unknown'
  };
};

export const getIntrusionBannerValue = (): string => '';
